module.exports = __webpack_public_path__ + "img/collection-engagementRings100Carat@2x.73d4b0b.jpg";